import { render } from "./DefaultModal.vue?vue&type=template&id=5b2a84b2&scoped=true"
import script from "./DefaultModal.vue?vue&type=script&lang=js"
export * from "./DefaultModal.vue?vue&type=script&lang=js"

import "./DefaultModal.vue?vue&type=style&index=0&id=5b2a84b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2a84b2"]])

export default __exports__